import styled from '@emotion/styled';

export const AppContainer = styled.div`
  padding: 16px;
  margin: 0 auto;
  width: 600px;
  background-color: #40e0d0;
`;

// export const Header = styled.h1`
//   margin: 16px 0;
//   text-align: center;
// `;
// export const Title = styled.h2`
//   margin: 16px 0;
//   text-align: center;
// `;
